<template>
  <div class="d-flex align-center flex-column justify-center">
    <v-card class="pdf-picker-item pa-3 ma-3 d-flex align-center" to="/farm/pdf_picker">
      <ChartlineIcon color="#E38C00" class="mr-2" style="width: 16px" />
      売上明細書を見る
    </v-card>
    <v-card class="pdf-picker-item pa-3 ma-3 d-flex align-center" to="/farm/shipping_results">
      <ChartlineIcon color="#E38C00" class="mr-2" style="width: 16px" />
      受領書を見る
    </v-card>
  </div>
</template>

<script>
import ChartlineIcon from "@/components/icons/ChartlineIcon.vue";

export default {
  components: {
    ChartlineIcon
  }
};
</script>

<style lang="scss" scoped>
.pdf-picker {
  &-item {
    width: 90%;
    height: 10rem;
    font: Bold 1rem Helvetica Neue;
    letter-spacing: 0.38px;
    color: #333333;
  }
}
</style>
